import React from "react";
import { Box, SimpleGrid, Wrap, WrapItem } from "@chakra-ui/react";
import { Cigarette, HouseIcon, Leaf, Wine } from "lucide-react";
import type { Lifestyle } from "src/types/matrimonyProfileDetails";
import InfoCard from "../InfoCard";
import IconStat from "../IconStat";
import EditButton from "../EditButton";
import { FIELD_LABELS } from "src/utils/matrimonyFieldLabels";

type LifestyleSectionProps = {
  lifestyle: Lifestyle;
  isOwnProfile: boolean;
  onEdit: () => void;
};

const LifestyleSection: React.FC<LifestyleSectionProps> = ({ lifestyle, isOwnProfile, onEdit }) => (
  <InfoCard
    title="Lifestyle"
    icon={<Leaf size={18} />}
    rightSlot={isOwnProfile ? <EditButton onClick={onEdit} /> : null}
  >
    {/* Mobile / tablet layout */}
    <Box display={{ base: "block", xl: "none" }}>
      <Wrap spacing={{ base: 3, md: 4 }}>
        <WrapItem flex={{ base: "1 1 46%", md: "1 1 200px" }}>
          <Box w="full">
            <IconStat icon={<Leaf size={20} />} label={FIELD_LABELS.DIET} value={lifestyle.diet} />
          </Box>
        </WrapItem>
        <WrapItem flex={{ base: "1 1 46%", md: "1 1 200px" }}>
          <Box w="full">
            <IconStat icon={<Wine size={20} />} label={FIELD_LABELS.DRINKING} value={lifestyle.drinking} />
          </Box>
        </WrapItem>
        <WrapItem flex={{ base: "1 1 46%", md: "1 1 200px" }}>
          <Box w="full">
            <IconStat icon={<Cigarette size={20} />} label={FIELD_LABELS.SMOKING} value={lifestyle.smoking} />
          </Box>
        </WrapItem>
        <WrapItem flex={{ base: "1 1 46%", md: "1 1 200px" }}>
          <Box w="full">
            <IconStat icon={<HouseIcon size={20} />} label={FIELD_LABELS.OWNS_HOUSE} value={lifestyle.ownsHouse} />
          </Box>
        </WrapItem>
      </Wrap>
    </Box>

    {/* Desktop layout */}
    <Box display={{ base: "none", xl: "block" }}>
      <SimpleGrid columns={4} spacing={4}>
        <IconStat icon={<Leaf size={20} />} label={FIELD_LABELS.DIET} value={lifestyle.diet} />
        <IconStat icon={<Wine size={20} />} label={FIELD_LABELS.DRINKING} value={lifestyle.drinking} />
        <IconStat icon={<Cigarette size={20} />} label={FIELD_LABELS.SMOKING} value={lifestyle.smoking} />
        <IconStat icon={<HouseIcon size={20} />} label={FIELD_LABELS.OWNS_HOUSE} value={lifestyle.ownsHouse} />
      </SimpleGrid>
    </Box>
  </InfoCard>
);

export default LifestyleSection;
